import { apiFetch } from "./client";

export const vaultApi = {
  getConfig: () => apiFetch<{ configured: boolean; vaultUrl: string | null }>("/vault/config"),
  test: () => apiFetch<{ success: boolean; count?: number; error?: string }>("/vault/test", { method: "POST" }),
  listSecrets: () => apiFetch<{ success: boolean; secrets: string[] }>("/vault/secrets"),
  getSecret: (name: string) => apiFetch<{ success: boolean; name: string; maskedValue: string }>(`/vault/secrets/${name}`),
  setSecret: (name: string, value: string) =>
    apiFetch<{ success: boolean }>(`/vault/secrets/${name}`, { method: "PUT", body: JSON.stringify({ value }) }),
};
